<template>
  <b-modal 
    :hide-footer="true" 
    :centered="true"
    modal-class="modal-curso-detalle"
    id="modal-curso-detalle-2" 
    size="lg"
    scrollable
  >
  <template #modal-header="{ close }">
		<img class="close" src="@/assets/img/close_red.png" @click="close()">
    <h6 class="sub-title"><span>{{examInfo ? examInfo.title : datosExam.name}}</span></h6>
	</template>
    <div class="description mb-4">
		<!-- <img src="@/assets/img/progress.png" /> -->
    <img :src="getImgObjetivoUrl(cursosJson.cursos.find(el => el.id == programacionExamen) != null ? cursosJson.cursos.find(el => el.id == programacionExamen).image : 'Objetivo 2.png')" class="img-box"/>
        <div v-if="examInfo" class="text">
          <p>{{examInfo.description}}</p>
          

          <p v-show="examInfo.sections"><strong>{{examInfo.sectionsDescription}}</strong></p>
          <ul v-show="examInfo.sections">
            <li v-for="item in examInfo.sections" :key="item.name" >{{item.name}}</li>
          </ul>

          <p v-if="examInfo.versions"><strong>{{examInfo.versionsDescription}}</strong></p>
          <ul  v-show="examInfo.versions">
            <li class="description2" v-for="item in examInfo.versions" :key="item.name" >{{item.name}}</li>
          </ul>
        </div>
        <div v-else class="text">
          <p>{{$t('planesYPrecios.paso-4.modal-curso-2.text')}} <strong>{{datosExam.name}}</strong></p>
        </div>
			
		</div>
		<div  v-if="examInfo" class="section_gray pt-5">
			<b-row>
				<b-col cols="7">
					<div class="card">
            <div class="card-body p-5">
              <h6 class="sub-title"><span>{{$t('planesYPrecios.paso-4.modal-curso-2.titulo')}}</span>{{$t('planesYPrecios.paso-4.modal-curso-2.subTitulo')}}</h6>
              <p>{{examInfo.process}}</p>
            </div>
          </div>
				</b-col>
				<b-col class="materials">
          <h6>{{$t('planesYPrecios.paso-4.modal-curso-2.material')}}</h6>
					<ul>
						<li v-for="item in examInfo.materials" :key="item.name">{{item.name}}</li>
					</ul>
				</b-col>
			</b-row>
		</div>
  </b-modal>
</template>


<script>
import  examenesJson  from '@/locales/material/examenes-es.json';
import  cursosJson  from '@/locales/material/cursos-es.json';
import  examenesJsonEN  from '@/locales/material/examenes-en.json';
import  cursosJsonEN  from '@/locales/material/cursos-en.json';

export default {
  data() {
    return {
		API_URL: process.env.VUE_APP_API_URL,
		examInfo: null,
	  cursosJson: localStorage.getItem('lang') == 'es' || localStorage.getItem('lang') ==  null ? cursosJson : cursosJsonEN,
    programacionExamen:0
    }
  },
  props: {
		datosExam: {
			type: Object,
		}
  },
  watch: { 
    	datosExam: function(newVal, oldVal) { // watch it

			if(newVal != null){
				this.getExamInfo();
			}
		}
	},
  created() {
		 
        
  },
  methods:{
		
		getExamInfo: function() {
      let _examenesJson = localStorage.getItem('lang') == 'es' || localStorage.getItem('lang') ==  null ? examenesJson : examenesJsonEN;
			
			this.examInfo = _examenesJson.cursos.find(el => el.codigo === this.datosExam.codigo);

			
    },
    getImgObjetivoUrl(name) {
		 
			if(name != null){
				let codeObjImg =  name.replaceAll("0", "")
				return  require(`@/assets/img/${codeObjImg}`);
			}else{
				return null;
			}
		},
  }
}
</script>